import CONST_DEMO from '../../../../includes/primitives/_constant_demo'
import CONST_KASKIDA from '../../../../includes/primitives/_constant_kaskida'
import CONST_GPL from '../../../../includes/primitives/_constant_gpl'
import CONST_TRINITY from '../../../../includes/primitives/_constant_trinity'
import Defs from '../../../../includes/primitives/colorDefs'

export default {
  data: () => ({
    const_demo: CONST_DEMO.HOST_NAME_RESOURCE + '/resources',
    const_kaskida: CONST_KASKIDA.HOST_NAME_RESOURCE + '/resources',
    const_gpl: CONST_GPL.HOST_NAME_RESOURCE + '/resources',
    const_trinity: CONST_TRINITY.HOST_NAME_RESOURCE + '/resources',

    HOST: null,
    rawData:  null,
    dataSet:  null,
    navigation:  null,

    canvasForms: null,
    canvasGantt: null,
    canvasGanttChart: null,

    toolBar: {
      department: [
        {value: 'Service',    file: 'dept_Service',    checked: true},
        {value: 'Developing', file: 'dept_Developing', checked: true},
        {value: 'System',     file: 'dept_System',     checked: true},
      ],

      filtering: [
        {file: 'filter_All',      checked: false},
        {file: 'filter_Remain',   checked: true},
        {file: 'filter_Thisweek', checked: false},
      ],

      timePeriod: [
        {month: -3,  checked: true},
        {month: -6,  checked: false},
        {month: -9,  checked: false},
        {month: -12, checked: false},
      ],
    },

    icon: {
      plus: 'm4.67,0C2.09,0,0,2.09,0,4.66c0,2.58,2.09,4.67,4.66,4.67,2.58,0,4.67-2.09,4.67-4.66h0C9.33,2.09,7.25,0,4.67,0m2.44,5.11c0,.12-.1.22-.22.22h-1.56v1.55c0,.12-.1.22-.22.22h-.89c-.12,0-.22-.1-.22-.22v-1.55h-1.56c-.12,0-.22-.1-.22-.22v-.89c0-.12.1-.22.22-.22h1.56v-1.55c0-.12.1-.22.22-.22,0,0,0,0,0,0h.89c.12,0,.22.1.22.22v1.55h1.56c.12,0,.22.1.22.22v.89Z',
      minus: 'm4.67,0C2.1,0,0,2.09,0,4.67s2.1,4.67,4.67,4.67,4.67-2.09,4.67-4.67S7.24,0,4.67,0Zm-.67,5.34h-1.56c-.12,0-.22-.1-.22-.22v-.89c0-.12.1-.22.22-.22h4.45c.12,0,.22.1.22.22v.89c0,.12-.1.22-.22.22h-2.89Z'
    },

    // Header
    header: {
      x: 10,
      y: 120,
      height: 35,
      columns: [
        {name: 'Phase',   code: '', width: 120, tColor: '#333',},
        {name: 'Group',   code: '', width: 150, tColor: '#333',},
        {name: 'Item',    code: '', width: 200, tColor: '#333',},
        {name: 'Rev.',    code: '', width: 30,  tColor: '#333',},
        {name: 'Status.', code: '', width: 70,  tColor: '#333',},
      ]
    },

    // Status
    status: [
      {id: 'REQ', name: 'Requested', tColor: '#bcbcbc', stroke: '#BDBCBC', color: '#E0E0DF',},
      {id: 'PLN', name: 'Planned',   tColor: '#bcbcbc', stroke: '#BDBCBC', color: '#E0E0DF',},
      {id: 'ISU', name: 'Issued',    tColor: '#757575', stroke: '#44A9DF', color: '#E0E0DF',},
      {id: 'PRO', name: 'Progress',  tColor: '#FFDA00', stroke: '#BDBCBC', color: '#FFDA00',},
      {id: 'COM', name: 'Completed', tColor: '#F7BACF', stroke: '#BDBCBC', color: '#F7BACF',},
      {id: 'DEV', name: 'Verified',  tColor: '#44A9DF', stroke: '#BDBCBC', color: '#B4E3FA',},
      {id: 'SVR', name: 'Launched',  tColor: '#8BC248', stroke: '#BDBCBC', color: '#8BC248',},
      {id: 'HLD', name: 'Hold',      tColor: '#F7BACF', stroke: '#BDBCBC', color: '#F7BACF',},
    ],

    // Modal - MenuItem
    menuItem: {
      columns: [
        {code: 'REV',      name: 'Rev.',      type: '',       width: 30 , align: 'middle', group: true,},
        {code: 'TITLE',    name: 'Title',     type: 'title',  width: 310, align: 'start' , group: true,},
        {code: 'STATUS',   name: 'Status',    type: 'status', width: 70,  align: 'middle', group: true,},
        {code: 'INCHARGE', name: 'Worker',    type: 'icon',   width: 50,  align: 'middle', group: true,},
        {code: 'REQUEST',  name: 'Request',   type: 'date',   width: 50,  align: 'middle', },
        {code: 'ISSUE',    name: 'Issue',     type: 'date',   width: 50,  align: 'middle', },
        {code: 'COMPLETE', name: 'Complete',  type: 'date',   width: 50,  align: 'middle', },
        {code: 'VERIFY',   name: '(Dev.)',    type: 'date',   width: 50,  align: 'middle', },
        {code: 'TARGET',   name: 'Plan Date', type: 'date',   width: 50,  align: 'middle', },
        {code: 'LAUNCH',   name: '(Service)', type: 'date',   width: 50,  align: 'middle', },
      ]
    },

    // Modal - MenuItem
    workorder: [
      {code: 'PHASE',     type: 'txt', align: 'start',  },
      {code: 'GROUP',     type: 'txt', align: 'start',  },
      {code: 'ITEM',      type: 'txt', align: 'start',  },
      {code: 'PLAN',      type: 'txt', align: 'middle', },
      {code: 'TARGET',    type: 'txt', align: 'middle', },
      {code: 'REQUESTOR', type: 'txt', align: 'middle', },
      {code: 'TITLE',     type: 'txt', align: 'start',  },
      {code: 'REV',       type: 'txt', align: 'middle', },
      {code: 'REQUEST',   type: 'btn', align: 'start',  status: 'Requested', color: '#bcbcbc', ex: 0,},
      {code: '',   type: 'btn', align: 'start',  status: 'Planned', color: '#bcbcbc', ex: 0,},
      {code: 'ISSUE',     type: 'btn', align: 'start',  status: 'Issued',    color: '#bcbcbc', ex: 80,},
      {code: 'PROG',      type: 'pro', align: 'middle', status: 'Progress',  color: '#ffda00', ex: 105,},
      {code: 'COMPLETE',  type: 'btn', align: 'start',  status: 'Completed', color: '#F7BACF', ex: 520,},
      {code: 'VERIFY',    type: 'btn', align: 'start',  status: 'Verified',  color: '#B4E3FA', ex: 600,},
      {code: 'LAUNCH',    type: 'btn', align: 'start',  status: 'Launched',  color: '#CDDC37', ex: 680,},
    ],


    keys:     null,
    filters:  null,
  }),


  
  computed: {
    ready2draw() {
      return (
        // this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },



  methods: {
    
    set_Styles() {
      let lightBlue = this.svg
      .append('defs')
      .append('linearGradient').attr('id', `shadowTimeline`).attr('x1', 0.5).attr('x2', 0.5).attr('y2', 1)
      lightBlue.append('stop').attr('stop-color', '#3d3d3d').attr('offset', '0').attr('stop-opacity', 0.5)
      lightBlue.append('stop').attr('stop-color', '#fff').attr('offset', '1').attr('stop-opacity', 0.3)

      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'LightGray', [ 0.5, 1.0, 0.5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'LightBlue', [.5, 1, .5, -.5], this.localId)
      Defs.setDefs_Gradients(this.svg, '', 'LinearA4', 'Pink', [.5, 1, .5, -.5], this.localId)

      let defs = this.svg.append('defs')
      // Window bar
      let windowBar = defs.append('linearGradient')
      .attr('id', `windowBar`).attr('x1', 0).attr('x2', 0).attr('y1', 0).attr('y2', 1)
      windowBar.append('stop').attr('stop-color', '#fff').attr('offset', '0').attr('stop-opacity', 1)
      windowBar.append('stop').attr('stop-color', '#F4F5F5').attr('offset', '.4').attr('stop-opacity', 1)
      windowBar.append('stop').attr('stop-color', '#F4F5F5').attr('offset', '.6').attr('stop-opacity', 1)
      windowBar.append('stop').attr('stop-color', '#fff').attr('offset', '1').attr('stop-opacity', 1)

      // // Contents Window
      let contentWindow = defs.append('linearGradient')
      .attr('id', `contentWindow`).attr('x1', 0).attr('x2', 0).attr('y1', 0).attr('y2', .7)
      contentWindow.append('stop').attr('stop-color', '#F4F5F5').attr('offset', '0').attr('stop-opacity', 1)
      contentWindow.append('stop').attr('stop-color', '#fff').attr('offset', '.1').attr('stop-opacity', 1)

      let filter = defs
      .append('filter').attr('id', 'dropshadow')

      filter.append('feGaussianBlur') .attr('in', 'SourceAlpha').attr('stdDeviation', 7).attr('result', 'blur')
      filter.append('feOffset').attr('in', 'blur').attr('dx', 2).attr('dy', 2).attr('result', 'offsetBlur')

      let feMerge = filter.append('feMerge')
      feMerge.append('feMergeNode').attr('in', 'offsetBlur')
      feMerge.append('feMergeNode').attr('in', 'SourceGraphic')

      let Kaskida = this.svg
      .append('defs')
      .append('linearGradient').attr('id', `kaskida`).attr('x1', 0).attr('x2', 1).attr('y1', 0.5).attr('y2', 0.5)
      Kaskida.append('stop').attr('stop-color', '#17562B').attr('offset', '0')
      Kaskida.append('stop').attr('stop-color', '#FEE70B').attr('offset', '1')
    },

  }
}